import React from 'react';

import {
  Box,
  styled
} from '@mui/material';



const StyledCode = styled('code')(() => ({
  fontSize: '10px'
}));

const BackgroundBox = styled(Box)(({ theme }) => ({
  backgroundColor: '#e6e6e6',
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius
}));



export interface IProps {
  content: string;
}

export const FC: React.FC<IProps> = props => {
  return (
    <BackgroundBox>
      <pre>
        <StyledCode>{props.content}</StyledCode>
      </pre>
    </BackgroundBox>
  );
};
